/* eslint-disable object-curly-newline */

export default {
	status: 200,
	data: {
		code: 200,
	},
};
